import { useQuery } from "@tanstack/react-query"
import { getConversationByUuid } from "~/services/superAdminService"
import { ConversationWithMessages } from '~/types/Conversations'

interface UseAdminConversationProps {
  uuid: string | null
}

const useAdminConversation = ({
  uuid
}: UseAdminConversationProps) => {
  const { data } = useQuery({
    queryKey: [uuid],
    queryFn: ({ queryKey }) => getConversationByUuid(queryKey[0] as string),
    initialData: null,
    enabled: !!uuid,
    meta: {
      persist: false
    },
    select: (data) => data as ConversationWithMessages
  })

  return data
}

export default useAdminConversation
